import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/layout/Layout';
import { Button } from '../components/ui/button';
import { Home, HelpCircle, ArrowLeft } from 'lucide-react';

const NotFoundPage = () => {
  return (
    <Layout hideBreadcrumbs>
      <div className="min-h-[60vh] flex items-center justify-center" data-testid="not-found-page">
        <div className="text-center max-w-md mx-auto px-4">
          {/* 404 Illustration */}
          <div className="mb-8">
            <h1 className="text-9xl font-bold text-gray-200">404</h1>
          </div>

          {/* Error Message */}
          <h2 className="text-2xl font-bold text-gray-800 mb-3">
            Page Not Found
          </h2>
          <p className="text-gray-600 mb-8">
            Oops! The page you're looking for doesn't exist or has been moved.
          </p>

          {/* Action Buttons */}
          <div className="flex flex-col sm:flex-row gap-3 justify-center mb-6">
            <Link to="/dashboard">
              <Button className="w-full sm:w-auto bg-[#0A7EA4] hover:bg-[#0A7EA4]/90">
                <Home className="w-4 h-4 mr-2" />
                Go to Dashboard
              </Button>
            </Link>
            <Button
              variant="outline"
              onClick={() => window.history.back()}
              className="w-full sm:w-auto"
            >
              <ArrowLeft className="w-4 h-4 mr-2" />
              Go Back
            </Button>
          </div>

          {/* Contact Us Link */}
          <div className="pt-4 border-t border-gray-200">
            <Link 
              to="/contact-us"
              className="text-sm text-gray-500 hover:text-[#0A7EA4] inline-flex items-center gap-1"
            >
              <HelpCircle size={14} />
              Need help? Contact us
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default NotFoundPage;
